import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserPermissionsService } from '@core/services/user-permissions.service';
import { ThemeService } from '@core/services/theme.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ButtonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'elixir-backoffice';
  private themeService = inject(ThemeService); // Instantiates ThemeService so the effect runs

  constructor(private userPermissionsService: UserPermissionsService) { }

  ngOnInit(): void {
    this.userPermissionsService.initializePermissions();
  }

  toggleDarkMode() {
    const element: any = document.querySelector('html');
    element.classList.toggle('elixir-backoffice-app-dark');
  }
}
